(function () {
  'use strict';

  var STAR_SVG =
    '<svg class="pdp-reviews__star" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';

  var DISCOVERY_PAGE_SIZE = 100;
  var DISCOVERY_HARD_CAP_PAGES = 20;

  function $(root, sel) { return root.querySelector(sel); }

  function starsHTML(rating) {
    var r = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    var out = '';
    for (var i = 0; i < r; i++) out += STAR_SVG;
    return out;
  }

  function formatDate(unix) {
    if (!unix) return '';
    var ms = Number(unix);
    if (!isFinite(ms) || ms <= 0) return '';
    try {
      return new Date(ms).toLocaleDateString(undefined, {
        year: 'numeric', month: 'short', day: 'numeric'
      });
    } catch (e) { return ''; }
  }

  // API returns product.name like "FLOW (dynamic chasing colors) / 1999-2006 GMC Sierra".
  // Split into variant + vehicle info on the " / " separator.
  function splitProductName(name) {
    if (!name) return null;
    var idx = name.indexOf(' / ');
    if (idx === -1) return { variant: name, vehicle: '' };
    return { variant: name.slice(0, idx), vehicle: name.slice(idx + 3) };
  }

  function fetchLooxQuickviewMedia(reviewId) {
    return fetch('https://shopify-app-loox-review.vercel.app/quickview/' + encodeURIComponent(reviewId))
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var mediaEl = doc.querySelector('body');
        return mediaEl ? mediaEl.outerHTML : null;
      });
  }

  function buildCard(template, review, onOpen) {
    var node = template.content.firstElementChild.cloneNode(true);

    $(node, '[data-slot="author"]').textContent = review.customer_name || 'Anonymous';

    var verified = $(node, '[data-slot="verified"]');
    if (review.is_verified) verified.hidden = false; else verified.remove();

    var dateEl = $(node, '[data-slot="date"]');
    var dateText = formatDate(review.reviewed_at_unix);
    if (dateText) {
      dateEl.textContent = dateText;
      dateEl.setAttribute('datetime', new Date(Number(review.reviewed_at_unix)).toISOString());
    } else {
      dateEl.remove();
    }

    var starsEl = $(node, '[data-slot="stars"]');
    starsEl.innerHTML = starsHTML(review.star_rating);
    starsEl.setAttribute('aria-label', (review.star_rating || 0) + ' out of 5 stars');

    var bodyEl = $(node, '[data-slot="body"]');
    if (review.review_body) bodyEl.textContent = review.review_body; else bodyEl.remove();

    var metaItemType = review.metadata || {};
    var metadataEl = $(node, '[data-slot="metadata"]');

    Object.keys(metaItemType).forEach(function(key) {
      var keyEl = document.createElement('span');
      keyEl.className = 'metakey';
      keyEl.textContent = key+":";

      var valEl = document.createElement('span');
      valEl.className = 'metabody';
      valEl.textContent = metaItemType[key];

      metadataEl.appendChild(keyEl);
      metadataEl.appendChild(valEl);
    });

    var productWrap = $(node, '[data-slot="product"]');
    var product = splitProductName(review.product && review.product.name);
    if (product) {
      $(node, '[data-slot="product-variant"]').textContent = product.variant;
      var vehEl = $(node, '[data-slot="product-vehicle"]');
      if (product.vehicle) vehEl.textContent = product.vehicle; else vehEl.remove();
      productWrap.hidden = false;
    } else {
      productWrap.remove();
    }

    var mediaWrap = $(node, '[data-slot="media"]');
    var media = review.review_image;
    if (media && media.url) {
      var img = $(node, '[data-slot="media-img"]');
      img.src = media.url;
      img.alt = media.alt || 'Customer review media';
      mediaWrap.hidden = false;
    } else {
      mediaWrap.remove();
    }

    node.addEventListener('click', function () { onOpen(review); });
    node.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onOpen(review);
      }
    });

    return node;
  }

  function createQuickview() {
    var el = document.createElement('div');
    el.className = 'pdp-reviews-quickview';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="pdp-reviews-quickview__dialog" data-dialog>' +
        '<button type="button" class="pdp-reviews-quickview__close" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>' +
          '</svg>' +
        '</button>' +
        '<div class="pdp-reviews-quickview__body">' +
          '<div class="pdp-reviews-quickview__media" data-media hidden>' +
            '<div data-media-slot></div>' +
          '</div>' +
          '<div class="pdp-reviews-quickview__details">' +
            '<h3 class="pdp-reviews-quickview__author" data-author></h3>' +
            '<div class="pdp-reviews-quickview__verified" data-verified hidden>' +
              '<span class="pdp-reviews-quickview__verified-icon">' +
                '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>' +
              '</span>' +
              '<span>Verified</span>' +
              '<button data-verified-notification id="i-icon" style="display: flex; position: relative;"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.682 1.33325 7.99998C1.33325 4.31798 4.31792 1.33331 7.99992 1.33331C11.6819 1.33331 14.6666 4.31798 14.6666 7.99998C14.6666 11.682 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.3333C9.41441 13.3333 10.771 12.7714 11.7712 11.7712C12.7713 10.771 13.3333 9.41447 13.3333 7.99998C13.3333 6.58549 12.7713 5.22894 11.7712 4.22874C10.771 3.22855 9.41441 2.66665 7.99992 2.66665C6.58543 2.66665 5.22888 3.22855 4.22868 4.22874C3.22849 5.22894 2.66659 6.58549 2.66659 7.99998C2.66659 9.41447 3.22849 10.771 4.22868 11.7712C5.22888 12.7714 6.58543 13.3333 7.99992 13.3333ZM7.33325 4.66665H8.66659V5.99998H7.33325V4.66665ZM7.33325 7.33331H8.66659V11.3333H7.33325V7.33331Z" fill="white" fill-opacity="1"></path></svg><div data-verified-notification-popup></div></button>'+
            '</div>' +
            '<div class="pdp-reviews-quickview__meta">' +
              '<div class="pdp-review-card__stars" data-stars></div>' +
              '<time class="pdp-reviews-quickview__date" data-date></time>' +
            '</div>' +
            '<p class="pdp-reviews-quickview__body-text" data-body></p>' +
            '<p class="pdp-reviews-quickview__metadata-text" data-metadata></p>' +
            '<div class="pdp-reviews-quickview__product" style="display: none;" data-product hidden>' +
              '<div class="pdp-reviews-quickview__product-label"></div>' +
              '<div class="pdp-reviews-quickview__product-variant" data-product-variant></div>' +
              '<div class="pdp-reviews-quickview__product-vehicle" data-product-vehicle></div>' +
            '</div>' +
          '</div>' +
          '<div class="verify-reviews-popup-container" data-verify-reviews-popup>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);

    var dialog = el.querySelector('[data-dialog]');
    var mediaWrap = el.querySelector('[data-media]');
    var mediaSlot = el.querySelector('[data-media-slot]');
    var closeBtn = el.querySelector('.pdp-reviews-quickview__close');
    var authorEl = el.querySelector('[data-author]');
    var verifiedEl = el.querySelector('[data-verified]');
    var verifiedNotificationEl = el.querySelector('[data-verified-notification]');
    var verifiedNotificationPopupEl = el.querySelector('[data-verified-notification-popup]');
    var verifyReviewPopupEl = el.querySelector('[data-verify-reviews-popup]');
    var starsEl = el.querySelector('[data-stars]');
    var dateEl = el.querySelector('[data-date]');
    var bodyEl = el.querySelector('[data-body]');
    var metadataEl = el.querySelector('[data-metadata]');
    var productEl = el.querySelector('[data-product]');
    var productVariantEl = el.querySelector('[data-product-variant]');
    var productVehicleEl = el.querySelector('[data-product-vehicle]');

    function close() {
      el.setAttribute('aria-hidden', 'true');
      mediaSlot.innerHTML = '';
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    closeBtn.addEventListener('click', close);
    el.addEventListener('click', function (e) {
      if (e.target === el) close();
    });

    return {
      open: function (review) {
        mediaSlot.innerHTML = '';
        verifiedNotificationEl.classList.remove("active")

        fetchLooxQuickviewMedia(review.review_id)
        .then(function (htmlStr) {
          // Parse and cache the doc
          var parser = new DOMParser();
          const cachedQuickviewDoc = parser.parseFromString(htmlStr, 'text/html');
          var mediaEl = cachedQuickviewDoc.querySelector('[data-testid="qv-review-media"]');

          mediaSlot.innerHTML = mediaEl.innerHTML;

          // Get content from cached quickview doc
          var notifEl = cachedQuickviewDoc
            ? cachedQuickviewDoc.querySelector('[data-element="notification-text"]')
            : null;

          if (notifEl) {
            notifEl.querySelectorAll('a').forEach(function (a) {
              var btn = document.createElement('label');
              btn.type = 'label';
              btn.setAttribute("for", review.review_id);

              // Copy attributes
              Array.from(a.attributes).forEach(function (attr) {
                btn.setAttribute(attr.name, attr.value);
              });

              // Copy inner content
              btn.innerHTML = a.innerHTML;

              a.parentNode.replaceChild(btn, a);
            });
          }

          // Get content from cached quickview doc
          var verifyReviewPopup = cachedQuickviewDoc
            ? cachedQuickviewDoc.querySelector('.verify-reviews-popup[data-verify-reviews-popup]')
            : null;

          
          var verifyReviewChecked = document.createElement('input');
          verifyReviewChecked.setAttribute("id", review.review_id);
          verifyReviewChecked.setAttribute("type", "checkbox");
          verifyReviewChecked.style.display = "none";
          verifyReviewPopup.appendChild(verifyReviewChecked);
          var verifyReviewLabel = document.createElement('label');
          verifyReviewLabel.type = 'label';
          verifyReviewLabel.setAttribute("for", review.review_id);
          verifyReviewLabel.innerHTML = `<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m12 15-4.243-4.243 1.415-1.414L12 12.172l2.828-2.829 1.415 1.414L12 15Z" fill="#161718"></path></svg>`;
          verifyReviewPopup.prepend(verifyReviewLabel);
          
          verifyReviewPopupEl.innerHTML = verifyReviewPopup.innerHTML;

          var tooltip = document.createElement('div');
          tooltip.className = 'pdp-verified-tooltip';
          tooltip.hidden = true;
          tooltip.innerHTML = notifEl.innerHTML;
          verifiedNotificationPopupEl.innerHTML = tooltip.innerHTML;

        })
        .catch(function () {});

        dialog.classList.add('pdp-reviews-quickview__dialog--has-media');

        authorEl.textContent = review.customer_name || 'Anonymous';
        verifiedEl.hidden = !review.is_verified;
        starsEl.innerHTML = starsHTML(review.star_rating);
        starsEl.setAttribute('aria-label', (review.star_rating || 0) + ' out of 5 stars');

        var dateText = formatDate(review.reviewed_at_unix);
        if (dateText) { dateEl.textContent = dateText; dateEl.hidden = false; }
        else dateEl.hidden = true;

        if (review.review_body) { bodyEl.textContent = review.review_body; bodyEl.hidden = false; }
        else bodyEl.hidden = true;

        var metaItemType = review.metadata || {};
        metadataEl.innerHTML = "";
        Object.keys(metaItemType).forEach(function(key) {
          var metaItemEl = document.createElement('div');
          metaItemEl.className = "pdp-reviews-quickview__product";
          var keyEl = document.createElement('span');
          keyEl.className = 'pdp-reviews-quickview__product-label';
          keyEl.textContent = key+":";

          var valEl = document.createElement('span');
          valEl.className = 'pdp-reviews-quickview__product-variant';
          valEl.textContent = metaItemType[key];

          metaItemEl.appendChild(keyEl);
          metaItemEl.appendChild(valEl);
          metadataEl.appendChild(metaItemEl);
        });

        var product = splitProductName(review.product && review.product.name);
        if (product) {
          productVariantEl.textContent = product.variant;
          if (product.vehicle) { productVehicleEl.textContent = product.vehicle; productVehicleEl.hidden = false; }
          else productVehicleEl.hidden = true;
          productEl.hidden = false;
        } else {
          productEl.hidden = true;
        }

        el.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', onKey);
        closeBtn.focus();
      }
    };
  }

  function PdpReviews(section) {
    var endpointBase = section.dataset.endpoint;
    var widgetId = section.dataset.widgetId;
    var productId = section.dataset.productId;
    var pageSize = Number(section.dataset.pageSize) || 10;

    var grid = $(section, '[data-pdp-reviews-grid]');
    var summaryAvg = $(section, '[data-pdp-reviews-summary-avg]');
    var summaryText = $(section, '[data-pdp-reviews-summary-text]');
    var emptyEl = $(section, '[data-pdp-reviews-empty]');
    var statusEl = $(section, '[data-pdp-reviews-status]');
    var loadMoreBtn = $(section, '[data-pdp-reviews-load-more]');
    var loadMoreWrap = loadMoreBtn ? loadMoreBtn.closest('.pdp-reviews__load-more-wrap') : null;
    var filterBtn = $(section, '[data-pdp-reviews-filter]');
    var filterMenu = $(section, '[data-pdp-reviews-filter-menu]');
    var filterOptions = filterMenu ? filterMenu.querySelectorAll('.pdp-reviews__filter-option') : [];
    var template = $(section, '[data-pdp-reviews-card-template]');
    var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;

    var quickview = createQuickview();

    var state = {
      allReviews: [],
      visible: [],
      rendered: 0,
      totalCount: 0,
      averageRating: 0,
      sort: 'featured'
    };

    function useMobileCarousel() {
      return document.body.classList.contains('template-product-pdp-redesign') &&
        mobileQuery &&
        mobileQuery.matches;
    }

    function isAtCarouselEnd() {
      if (!useMobileCarousel()) return true;
      if (grid.scrollWidth <= grid.clientWidth + 1) return true;
      return grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 8;
    }

    function placeLoadMore() {
      if (loadMoreWrap && loadMoreWrap.parentNode !== grid) {
        grid.appendChild(loadMoreWrap);
      } else if (loadMoreWrap) {
        grid.appendChild(loadMoreWrap);
      }
    }

    function updateLoadMoreVisibility() {
      var hasMore = state.rendered < state.visible.length;
      if (loadMoreWrap) placeLoadMore();
      if (!hasMore) {
        loadMoreBtn.hidden = true;
        if (loadMoreWrap) loadMoreWrap.hidden = true;
        return;
      }
      loadMoreBtn.hidden = false;
      if (loadMoreWrap) loadMoreWrap.hidden = false;
    }

    function setStatus(msg, isError) {
      if (!msg) {
        statusEl.hidden = true;
        statusEl.textContent = '';
        statusEl.classList.remove('pdp-reviews__status--error');
        return;
      }
      statusEl.hidden = false;
      statusEl.textContent = msg;
      statusEl.classList.toggle('pdp-reviews__status--error', !!isError);
    }

    function updateSummary() {
      if (!state.totalCount) {
        summaryAvg.textContent = '';
        summaryText.textContent = 'No reviews yet';
        return;
      }
      var avgStr = (Math.round(state.averageRating * 10) / 10).toFixed(1);
      summaryAvg.textContent = avgStr;
      summaryText.textContent = 'Based on ' + state.totalCount + ' review' + (state.totalCount === 1 ? '' : 's');
    }

    function buildUrl(page, limit) {
      var base = endpointBase.replace(/\/$/, '');
      return base + '/' + encodeURIComponent(widgetId) + '/' + encodeURIComponent(productId) +
        '?page=' + page + '&limit=' + limit;
    }

    function fetchPage(page, limit) {
      return fetch(buildUrl(page, limit), { credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        });
    }

    function computeAverage(reviews) {
      if (!reviews.length) return 0;
      var sum = 0;
      for (var i = 0; i < reviews.length; i++) sum += Number(reviews[i].star_rating) || 0;
      return sum / reviews.length;
    }

    function sortReviews(list, sort) {
      var copy = list.slice();
      if (sort === 'newest') {
        copy.sort(function (a, b) { return Number(b.reviewed_at_unix || 0) - Number(a.reviewed_at_unix || 0); });
      } else if (sort === 'highest') {
        copy.sort(function (a, b) { return (Number(b.star_rating) || 0) - (Number(a.star_rating) || 0); });
      } else if (sort === 'lowest') {
        copy.sort(function (a, b) { return (Number(a.star_rating) || 0) - (Number(b.star_rating) || 0); });
      }
      return copy;
    }

    function renderReset() {
      grid.innerHTML = '';
      grid.scrollLeft = 0;
      state.rendered = 0;
      renderNextBatch();
    }

    function renderNextBatch() {
      var end = Math.min(state.rendered + pageSize, state.visible.length);
      if (end <= state.rendered) {
        updateLoadMoreVisibility();
        return;
      }
      var frag = document.createDocumentFragment();
      for (var i = state.rendered; i < end; i++) {
        frag.appendChild(buildCard(template, state.visible[i], function (r) { quickview.open(r); }));
      }
      grid.appendChild(frag);
      state.rendered = end;
      placeLoadMore();
      window.requestAnimationFrame(updateLoadMoreVisibility);
    }

    function applySort() {
      state.visible = sortReviews(state.allReviews, state.sort);
      renderReset();
    }

    function ingestFirstPage(data) {
      var reviews = (data && data.reviews) || [];
      state.allReviews = reviews.slice();
      if (data && typeof data.total_reviews === 'number') state.totalCount = data.total_reviews;
      else state.totalCount = reviews.length;
      if (data && typeof data.average_rating === 'number') state.averageRating = data.average_rating;
      else state.averageRating = computeAverage(reviews);
    }

    function fetchRemainingPages(firstPageData) {
      var firstCount = (firstPageData && firstPageData.reviews && firstPageData.reviews.length) || 0;
      var expectedTotal = Number(state.totalCount) || firstCount;
      if (!firstCount || state.allReviews.length >= expectedTotal) return Promise.resolve();
      var page = 2;
      function next() {
        if (page > DISCOVERY_HARD_CAP_PAGES) return Promise.resolve();
        if (state.allReviews.length >= expectedTotal) return Promise.resolve();
        return fetchPage(page, DISCOVERY_PAGE_SIZE).then(function (data) {
          var reviews = (data && data.reviews) || [];
          if (!reviews.length) return;
          state.allReviews = state.allReviews.concat(reviews);
          state.totalCount = Math.max(expectedTotal, state.allReviews.length);
          if (!(firstPageData && typeof firstPageData.average_rating === 'number')) {
            state.averageRating = computeAverage(state.allReviews);
          }
          updateSummary();
          // Also refresh visible list under the current sort
          state.visible = sortReviews(state.allReviews, state.sort);
          page += 1;
          return next();
        });
      }
      return next();
    }

    function init() {
      setStatus('Loading reviews…');
      fetchPage(1, DISCOVERY_PAGE_SIZE)
        .then(function (data) {
          ingestFirstPage(data);
          setStatus(null);
          if (!state.allReviews.length) {
            emptyEl.hidden = false;
            updateSummary();
            return;
          }
          updateSummary();
          state.visible = sortReviews(state.allReviews, state.sort);
          renderNextBatch();
          return fetchRemainingPages(data);
        })
        .then(function () {
          updateLoadMoreVisibility();
        })
        .catch(function () {
          setStatus('Could not load reviews. Please try again later.', true);
          loadMoreBtn.hidden = true;
          if (loadMoreWrap) loadMoreWrap.hidden = true;
        });
    }

    loadMoreBtn.addEventListener('click', renderNextBatch);
    grid.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateLoadMoreVisibility);
    }, { passive: true });
    window.addEventListener('resize', updateLoadMoreVisibility);
    if (mobileQuery && mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', updateLoadMoreVisibility);
    } else if (mobileQuery && mobileQuery.addListener) {
      mobileQuery.addListener(updateLoadMoreVisibility);
    }

    // Filter / sort menu
    function closeFilter() {
      filterMenu.hidden = true;
      filterBtn.setAttribute('aria-expanded', 'false');
    }
    function openFilter() {
      filterMenu.hidden = false;
      filterBtn.setAttribute('aria-expanded', 'true');
    }
    filterBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (filterMenu.hidden) openFilter(); else closeFilter();
    });
    document.addEventListener('click', function (e) {
      if (!filterMenu.hidden && !filterMenu.contains(e.target) && e.target !== filterBtn) closeFilter();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !filterMenu.hidden) closeFilter();
    });
    for (var i = 0; i < filterOptions.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var sort = btn.dataset.sort;
          state.sort = sort;
          for (var j = 0; j < filterOptions.length; j++) {
            filterOptions[j].classList.toggle('is-active', filterOptions[j] === btn);
          }
          closeFilter();
          applySort();
        });
      })(filterOptions[i]);
    }

    init();
  }

  function init() {
    var sections = document.querySelectorAll('[data-pdp-reviews]');
    for (var i = 0; i < sections.length; i++) PdpReviews(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }








  document.querySelectorAll(`[data-loox-write-review]`).forEach((lwr) => {


    lwr.addEventListener("click", function (e) {
      const btn = e.target;
      if (!btn) return;

      e.preventDefault();

      // take URL from data-url OR build from product/widget
      const url =
        btn.dataset.looxWriteReviewUrl ||
        `https://loox.io/widget/${btn.dataset.widgetId}/ugc/review-form?productId=${btn.dataset.productId}&frame_id=loox-review-form-ugc-dialog`;

      if (!url) return;

      // remove existing overlay if any
      const existing = document.getElementById("looxOverlay_loox-review-form-ugc-dialog");
      if (existing) existing.remove();

      // overlay
      const overlay = document.createElement("div");
      overlay.id = "looxOverlay_loox-review-form-ugc-dialog";
      overlay.className = "loox-overlay";
      overlay.style.width = "100%";
      overlay.style.height = "100%";
      overlay.style.position = "fixed";
      overlay.style.inset = "0";
      overlay.style.padding = "0";
      overlay.style.margin = "0";
      overlay.style.zIndex = "2147483646";
      overlay.style.opacity = "1";
      overlay.style.transition = "opacity 400ms ease-in";
      overlay.style.backgroundColor = "rgba(0, 0, 0, 0.3)";
      overlay.style.overflow = "hidden";
      overlay.style.colorScheme = "none";

      // iframe
      const iframe = document.createElement("iframe");
      iframe.id = "loox-review-form-ugc-dialog";
      iframe.src = url;
      iframe.allowFullscreen = true;
      iframe.setAttribute("allow", "fullscreen; web-share; clipboard-read; clipboard-write");
      iframe.title = "";
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "0";
      iframe.style.padding = "0";
      iframe.style.margin = "0";
      iframe.style.display = "block";

      overlay.appendChild(iframe);
      document.body.appendChild(overlay);

      // close on overlay click (click outside iframe)
      overlay.addEventListener("click", function (ev) {
        if (ev.target === overlay) overlay.remove();
      });

      // close on ESC
      const onEsc = (ev) => {
        if (ev.key === "Escape") {
          overlay.remove();
          document.removeEventListener("keydown", onEsc);
        }
      };
      document.addEventListener("keydown", onEsc);
    });


  });

})();
